import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import KraEmpReviewDetailsSection from "./kraempReviewDetailsSection";
import CommonSelect from "../../../core/common/commonSelect";
import useApi from "../../../core/customhook/useApi";
import FeatherIcon from "feather-icons-react";

const statusChoose = [
  { value: "1", label: "Active" },
  { value: "0", label: "Inactive" },
];

const EmployeeKraReview = () => {
  const [empname, setEmpname] = useState("");
  const [empnameID, setEmpnameID] = useState("");
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState<any[]>([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [allItemList, setAllItemList] = useState<any[]>([]);
  const [newItem, setNewItem] = useState<any>({
    band: "",
    category: "",
    smartGoal: "",
    target: "",
    target_date: "",
  });
  const [selectedItem, setSelectedItem] = useState<any>({});
  const [showReviewDetail, setShowReviewDetail] = useState<boolean>(false);

  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const fyStart = month >= 3 ? year : year - 1;
    return formatFinancialYear(fyStart);
  };
  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());

  const columns = [
    {
      title: "Sr No.",
      dataIndex: "SrNo",
      render: (text: string, record: any, index: number) => (
        <h6 className="fw-medium fs-14 text-dark" style={{ width: "50px" }}>
          {index + 1}
        </h6>
      ),
      // sorter: (a: any, b: any) => a.SrNo - b.SrNo,
    },
    {
      title: "Employee ID",
      dataIndex: "employee_id",
      render: (text: string) => <p style={{ width: "max-content" }}>{text}</p>,
      sorter: (a: any, b: any) => a.employee_id.localeCompare(b.employee_id),
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      render: (text: string) => <p style={{ width: "150px" }}>{text}</p>,
      sorter: (a: any, b: any) =>
        a.employee_name.localeCompare(b.employee_name),
    },
    {
      title: "Category",
      dataIndex: "category_name",
      render: (text: string) => <p style={{ width: "100px" }}>{text}</p>,
      sorter: (a: any, b: any) =>
        a.category_name.localeCompare(b.category_name),
    },
    {
      title: "Category Description",
      dataIndex: "category_description",
      render: (text: string) => <p style={{ width: "200px" }}>{text}</p>,
      sorter: (a: any, b: any) =>
        a.category_description.localeCompare(b.category_description),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string, record: any) => (
        <>
          <span
            className={`badge ${
              text === "M_APPROVED" || text === "E_SUBMIT"
                ? "badge-success"
                : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text === "M_APPROVED"
              ? "Manager Approved"
              : text === "M_DRAFT"
              ? "Manager Pending"
              : text === "E_SUBMIT"
              ? "Employee Submited"
              : "Employee Pending"}
          </span>
        </>
      ),
      // sorter: (a: any, b: any) => a.attachment.localeCompare(b.attachment),
      sorter: (a: any, b: any) => a.status.length - b.status.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: any, record: any) => (
        <div
          className="action-icon d-inline-flex"
          style={{ width: "max-content" }}
        >
          <Link
            to="/performance/performance-review-manager"
            className="me-2"
            onClick={() => {
              localStorage.setItem("PmsEmpID", record.employee_id);
            }}
          >
            <i className="ti ti-edit" />
          </Link>
        </div>
      ),
    },
  ];

  const employeeColumns = [
    {
      title: "EmpCode",
      dataIndex: "employee_id",
      render: (text: string, record: any) => (
        <Link
          to="#"
          onClick={() => {
            setEmpname(record.employee_name);
            setModalOpen(false);
          }}
          style={{ textDecoration: "underline", cursor: "pointer" }}
          data-bs-dismiss="modal"
        >
          {text}
        </Link>
      ),
      sorter: (a: any, b: any) => a.employee_id.localeCompare(b.employee_id),
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      render: (text: string, record: any) => (
        <Link
          to="#"
          onClick={() => {
            setEmpname(record.employee_name);
            setEmpnameID(record.employee_id);
            setModalOpen(false);
          }}
          style={{ textDecoration: "underline", cursor: "pointer" }}
          data-bs-dismiss="modal"
        >
          {text}
        </Link>
      ),
      sorter: (a: any, b: any) =>
        a.employee_name.localeCompare(b.employee_name),
    },
    {
      title: "Designation",
      dataIndex: "designation", // Change From to designation
      sorter: (a: any, b: any) => a.designation.localeCompare(b.designation),
    },
    {
      title: "Department",
      dataIndex: "department", // Change To to department
      sorter: (a: any, b: any) => a.department.localeCompare(b.department),
    },
    {
      title: "Locatation",
      dataIndex: "branch_name", // Change To to branch_name
      sorter: (a: any, b: any) => a.branch_name.localeCompare(b.branch_name),
    },
  ];

  const {
    data: teamData,
    loading: teamLoading,
    error: teamError,
  } = useApi("/api/manager/team-member", {
    method: "GET",
    autoCall: true,
  });
  const data = teamData?.data;

  const {
    data: getEmpPmsdetails,
    loading: EmpPmsdetailsLoading,
    error: EmpPmsdetailsError,
    callApi: PMSEMPDetails,
  } = useApi("/api/manager/view-employee-review", {
    method: "POST",
    payload: {
      employee_id: "",
      financial_year: finance_year,
    },
    autoCall: true,
  });

  useEffect(() => {
    if (getEmpPmsdetails?.success) setAllItemList(getEmpPmsdetails?.data);
  }, [getEmpPmsdetails]);

  const getEmpPmsRecord = async () => {
    const payload = {
      employee_id: empnameID,
      financial_year: finance_year,
    };
    try {
      const response = await PMSEMPDetails(payload);
      if (response.success) {
        setAllItemList(response?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = <T extends Object>(
    setter: React.Dispatch<React.SetStateAction<T>>,
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    // console.log(name, value)
    setter((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelect = (
    option: any,
    fieldName: string,
    setter: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setter((prev: any) => ({
      ...prev,
      [fieldName]: String(option?.value),
    }));
  };

  const UpdateItemData = async (e: any) => {
    e.preventDefault();
    try {
      // const resp = await AXIOSCONFIGMETHOD("put", webServiceUrl. , {
      // })
      // if (resp?.data?.success) {
      //     fetchData()
      //     toast.success(resp?.data?.message)
      // }
    } catch (error) {
      console.error("Error while updating :", error);
    }
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Employee Reviews</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Dashboard</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    All Employee Reviews
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
              {}
              <div className="input-icon w-120 position-relative mb-2">
                <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {(() => {
                    const today = new Date();
                    const currentYear =
                      today.getMonth() >= 3
                        ? today.getFullYear()
                        : today.getFullYear() - 1;

                    return Array.from({ length: 1 }, (_, i) => {
                      const year = currentYear - i;
                      const nextYearShort = String(year + 1).slice(-2);
                      const financialYear = `${year}-${nextYearShort}`;

                      return (
                        <option key={financialYear} value={financialYear}>
                          {financialYear}
                        </option>
                      );
                    });
                  })()}
                </select>
              </div>
            </div>
          </div>
          <div className=" mb-3 bg-white rounded-3 p-3 shadow-sm d-flex justify-content-between gap-5">
            <div className="mb-1" style={{ flex: "1", position: "relative" }}>
              <input
                type="text"
                name="empname"
                id="employeeSearch"
                className="form-control"
                placeholder="Type name / code"
                value={empname}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const value = e.target.value;
                  setEmpname(value);
                  setEmpnameID(value);
                  if (value.trim()) {
                    const matches = data.filter((item: any) =>
                      item.employee_name
                        .toLowerCase()
                        .includes(value.toLowerCase())
                    );
                    setFilteredSuggestions(matches);
                    setShowSuggestions(true);
                  } else {
                    setFilteredSuggestions([]);
                    setShowSuggestions(false);
                  }
                }}
              />

              {/* Modal Open Button */}
              <button
                type="button"
                className="btn btn-primary btn-sm"
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "8px",
                  transform: "translateY(-50%)",
                  padding: "4px 8px",
                }}
                onClick={() => setModalOpen(true)}
                data-bs-toggle="modal"
                data-bs-target="#employee_data_modal"
              >
                <FeatherIcon icon="more-horizontal" size="16" />
              </button>

              {/* Suggestion Dropdown */}
              {showSuggestions && filteredSuggestions.length > 0 && (
                <ul
                  className="dropdown-menu show"
                  style={{
                    width: "100%",
                    maxHeight: "200px",
                    overflowY: "auto",
                    position: "absolute",
                    zIndex: 1000,
                  }}
                >
                  {filteredSuggestions.map((item, index) => (
                    <li
                      key={index}
                      className="dropdown-item"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setEmpname(item.employee_name);
                        setEmpnameID(item.employee_id);
                        setShowSuggestions(false);
                      }}
                    >
                      {item.employee_id} - {item.employee_name}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <button
              className="btn btn-primary px-3 py-0"
              onClick={getEmpPmsRecord}
            >
              Search
            </button>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Employee Review List</h5>
            </div>
            <div className="card-body p-0">
              {showReviewDetail ? (
                <>
                  <KraEmpReviewDetailsSection data={selectedItem} />
                </>
              ) : (
                <Table
                  dataSource={allItemList}
                  columns={columns}
                  Selection={false}
                />
              )}
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">
            © {new Date().getFullYear()} WeConnect. All rights reserved.
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}

      {/* Edit Modal */}
      <div className="modal fade" id="edit_empreview">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title text-capitalize">
                Edit Employee Review
              </h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={UpdateItemData}>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Category<span className="text-danger">*</span>
                      </label>
                      <CommonSelect
                        className="select"
                        options={statusChoose}
                        defaultValue={selectedItem?.category || ""}
                        onChange={(option) => {
                          handleSelect(option, "category", setSelectedItem);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Smart Goal <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="smartGoal"
                        value={selectedItem?.smartGoal || ""}
                        onChange={(e) => handleChange(setSelectedItem, e)}
                        className="form-control"
                        placeholder=" Enter Smart Goal...."
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Target <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="target"
                        value={selectedItem?.target}
                        onChange={(e) => handleChange(setSelectedItem, e)}
                        className="form-control"
                        placeholder=" Enter Target...."
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Target Achievement Date{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        name="target_achievement_date"
                        value={selectedItem?.target_achievement_date || ""}
                        onChange={(e) => {
                          handleChange(setSelectedItem, e);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Attachment <span className="text-danger">*</span>
                      </label>
                      <input
                        type="file"
                        name="Attachment"
                        // value={new}
                        className="form-control"
                        onChange={(e) => {
                          const file = e?.target?.files;
                          if (file && file.length > 0) {
                            setNewItem((prev: any) => ({
                              ...prev,
                              Attachment: file[0],
                            }));
                          }
                        }}
                      />
                      <p className=" pt-2 mb-3 muted-text">
                        Upload pdf only and size will be less than or equal to 2
                        MB
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${modalOpen ? "show" : ""}`}
        id="employee_data_modal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden={!modalOpen}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <img
                src="/assets/img/logo/weconnectlogo.png"
                alt=""
                style={{ height: "50px" }}
              />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setModalOpen(false)}
              />
            </div>
            <div className="modal-body">
              <div className="card-body p-0">
                <Table
                  dataSource={data}
                  columns={employeeColumns}
                  Selection={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeKraReview;
